import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 8h1v8","key":"svg-0"}],["path",{"d":"M7 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3","key":"svg-1"}]]

const IconNumber91Small = createReactComponent('outline', 'number-91-small', 'Number91Small', __iconNode);

export default IconNumber91Small;